import React from "react";
import { BlogLearnMore } from "@/.storyblok/types/319751/storyblok-components";
import { storyblokEditable, SbBlokData } from "@storyblok/react";
// import { logger } from '@/lib/logger';

interface BlogLearnMoreProps {
  blok?: BlogLearnMore & SbBlokData;
}

const BlogLearnMoreComponent: React.FC<BlogLearnMoreProps> = ({ blok }) => {
  if (!blok) return null;

  // logger.log(`BlogPostLearnMore:` + blok);

  const { title, description, cta_button, cta_button_link } = blok;

  return (
    <section
      {...(blok && storyblokEditable(blok))}
      className="bg-light text-center py-4 py-md-5"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-20 col-xl-18 col-xxl-16">
            {title && <h2 className="text-secondary d-block">{title}</h2>}

            {description && <p>{description}</p>}

            {cta_button && cta_button_link?.cached_url && (
              <a
                target="_blank"
                className="btn btn-secondary btn-lg mt-3"
                href={cta_button_link.cached_url}
              >
                {cta_button}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogLearnMoreComponent;